import { IsBoolean } from 'class-validator';
import { NamedEntityDto } from '../clinical-details';

export class ImageQualityRatingDto extends NamedEntityDto {
  @IsBoolean()
  requiresReason: boolean;
}
